//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'

import { EthAddr } from '@shared/SchemaTypes'

export default function AdminTransferMintDestination(_props: { poolAddr: EthAddr }): React.ReactElement {
  throw new Error('TODOV5 Not implemented')
  // const { poolAddr } = props
  // const dispatch = useOtDispatch()
  // const [poolCrossChainTransferCTO, setPoolCrossChainTransferCTO] = React.useState<
  //   PoolCrossChainTransferCTO | undefined
  // >(undefined)
  // const poolBaseOverviewCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO])

  // const { chainId, restAPIKey, serverApiBaseUrl, providerReadOnly, signer } = useOtChainStateUserConnection()
  // useEffect(() => {
  //   if (poolAddr && chainId && serverApiBaseUrl && providerReadOnly) {
  //     poolCrossChainTransferFetch(serverApiBaseUrl, restAPIKey, poolAddr).then(
  //       (_poolCrossChainTransferCTO: PoolCrossChainTransferCTO | undefined) => {
  //         setPoolCrossChainTransferCTO(_poolCrossChainTransferCTO)
  //       }
  //     )
  //   }
  // }, [chainId, serverApiBaseUrl, providerReadOnly, poolAddr])

  // const handleCancel = (): void => {
  //   const event = new Event('modalClose')
  //   window.dispatchEvent(event)
  // }
  // if (!poolCrossChainTransferCTO) {
  //   return <Typography variant="h2">Loading ....</Typography>
  // }

  // const handleTransferRequest = async (): Promise<void> => {
  //   updatePoolOffchainData()
  //     .then(() => {
  //       const event = new Event('modalClose')
  //       window.dispatchEvent(event)
  //     })
  //     .catch((e) => {
  //       logOT.error(e)
  //     })

  //   async function updatePoolOffchainData() {
  //     const destPoolCrossTrainTransferCTO: PoolCrossChainTransferCTO | undefined = await poolCrossChainTransferFetch(
  //       serverApiBaseUrl,
  //       restAPIKey,
  //       poolAddr
  //     )
  //     if (!poolAddr || !signer) {
  //       throw new Error('destPoolCrossTrainTransferCTO is undefined')
  //     }

  //     if (!destPoolCrossTrainTransferCTO) {
  //       throw new Error('destPoolCrossTrainTransferCTO is undefined')
  //     }

  //     const sourceDeployment = DEPLOYMENT_CONFIGURATIONS.find(
  //       (config: DeploymentConfiguration) =>
  //         config.deploymentName === destPoolCrossTrainTransferCTO.sourceDeploymentName
  //     )
  //     if (!sourceDeployment?.serverApiBaseUrl) {
  //       throw new Error('destPoolCrossTrainTransferCTO is undefined')
  //     }
  //     const sourcePoolCrossTrainTransferCTO: PoolCrossChainTransferCTO | undefined = await poolCrossChainTransferFetch(
  //       sourceDeployment?.serverApiBaseUrl,
  //       restAPIKey,
  //       destPoolCrossTrainTransferCTO.sourcePoolAddr
  //     )
  //     if (!sourcePoolCrossTrainTransferCTO) {
  //       throw new Error('sourcePoolCrossTrainTransferCTO is undefined')
  //     }

  //     try {
  //       destPoolCrossTrainTransferCTO.transferStep = TransferStepNumbers.Destination_Mint_Pending
  //       destPoolCrossTrainTransferCTO.transferStepName = TransferStepNames.Destination_Mint_Pending

  //       await poolCrossChainTransferPut(
  //         sourceDeployment.serverApiBaseUrl,
  //         sourceDeployment.restAPIKey,
  //         serverApiBaseUrl,
  //         restAPIKey,
  //         destPoolCrossTrainTransferCTO
  //       )

  //       if (poolBaseOverviewCTO?.poolType === PoolTypeEnum.Term) {
  //         const pool = new ethers.Contract(poolAddr, PoolAbi, signer)
  //         const poolControllerAddr = await pool.poolController()
  //         logOT.info(
  //           '#CrossChain poolControllerAddr',
  //           poolControllerAddr,
  //           ' To Wallet',
  //           destPoolCrossTrainTransferCTO.destinationWalletAddr
  //         )

  //         const accountings = await pool.accountings()
  //         logOT.info('#CrossChain accountings', accountings)

  //         const isPermittedLender = await pool.isPermittedLender(destPoolCrossTrainTransferCTO.destinationWalletAddr)

  //         logOT.info('#CrossChain isPermittedLender', isPermittedLender)

  //         logOT.info('#CrossChain state', await pool.state())

  //         logOT.info('#CrossChain activeLoan', await pool.activeLoan())

  //         const poolControlerContract = new ethers.Contract(poolControllerAddr, PoolControllerAbi, signer)

  //         const tx = await (
  //           poolControlerContract.connect(signer) as unknown as PoolController
  //         ).crossChainTransferMintDestination(
  //           destPoolCrossTrainTransferCTO.destinationWalletAddr,
  //           BigInt(destPoolCrossTrainTransferCTO.amount)
  //         )
  //         await tx.wait(1)
  //       } else {
  //         const pool = new ethers.Contract(poolAddr, PoolFlexAbi, signer)
  //         const poolControllerAddr = await pool.poolController()
  //         logOT.info('poolControllerAddr', poolControllerAddr)

  //         const poolControlerContract = new ethers.Contract(poolControllerAddr, PoolControllerFlexAbi, signer)

  //         const tx = await (
  //           poolControlerContract.connect(signer) as unknown as PoolController
  //         ).crossChainTransferMintDestination(
  //           destPoolCrossTrainTransferCTO.destinationWalletAddr,
  //           BigInt(destPoolCrossTrainTransferCTO.amount)
  //         )
  //         await tx.wait(1)
  //       }
  //     } catch (e: any) {
  //       console.error('#error', e)
  //       const alertCTO: AlertCTO = alertCTOFromError(e, ActivityEnum.ChainTransfer)
  //       console.error('#error alertCTO', alertCTO)
  //       dispatch(alertActions.addAlert(alertCTO))
  //       throw e
  //     }
  //     destPoolCrossTrainTransferCTO.transferStep = TransferStepNumbers.Destination_Minted
  //     destPoolCrossTrainTransferCTO.transferStepName = TransferStepNames.Destination_Minted

  //     await poolCrossChainTransferPut(
  //       sourceDeployment.serverApiBaseUrl,
  //       sourceDeployment.restAPIKey,

  //       serverApiBaseUrl,
  //       restAPIKey,
  //       destPoolCrossTrainTransferCTO
  //     )
  //   }
  // }

  // return (
  //   <Box py={2} px={2} width={500}>
  //     <Grid container spacing={6}>
  //       <Grid sx={{ marginTop: 2 }} item xs={12}>
  //         <SectionHeader>Source</SectionHeader>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Chain ID
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {chainId}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Vault Address
  //         </Typography>
  //         <AddressPill addr={poolAddr} />
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Account
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           <AddressPill addr={poolCrossChainTransferCTO.sourceWalletAddr} />
  //         </Typography>
  //       </Grid>
  //       <Grid sx={{ marginTop: 2 }} item xs={12}>
  //         <SectionHeader>Destination</SectionHeader>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Destination Chain ID
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {poolCrossChainTransferCTO.destinationChainId}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Destination Vault Address
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           <AddressPill addr={poolCrossChainTransferCTO?.destinationPoolAddr} />
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography variant="bodyBold" align="center" margin="dense">
  //           Amount {erc20WeiToCommaDecString(poolCrossChainTransferCTO?.amount)} {poolBaseOverviewCTO?.liquidityTokenSymbol}
  //         </Typography>
  //         <AddressPill addr={poolCrossChainTransferCTO?.destinationWalletAddr} />
  //       </Grid>
  //       <Grid item xs={12} sm={12}>
  //         <ButtonAction
  //           data-testid={'TransferRequest'}
  //           sx={{ marginRight: '16px' }}
  //           variant={'primary'}
  //           onClick={handleTransferRequest}
  //         >
  //           Transfer Request
  //         </ButtonAction>

  //         <ButtonAction variant={'tertiary'} onClick={handleCancel}>
  //           Cancel
  //         </ButtonAction>
  //       </Grid>
  //     </Grid>
  //   </Box>
  // )
}
